import { HttpErrorResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { ApiResponse } from "../dto";

export function normalizeHttpError<T>(err: HttpErrorResponse): ApiResponse<T> {

  let message = 'Ocurrió un error inesperado';

  if (err?.error?.Message) {
    message = err.error.Message;
  }
  else if (err?.error?.error_description) {
    message = err.error.error_description;
  }
  else if (typeof err?.error === 'string') {
    message = err.error;
  }
  else if (err.message) {
    message = err.message;
  }

  return {
    Success: false,
    Data: null,
    Message: message
  };
}

export function handleApiError<T>() {
  return (err: any) => of(normalizeHttpError<T>(err));
}
